//login-vendor

/*
 * Dependencies: external libs.
 */
// FIXME find NPM equivalents or see if they are needed post BABEL (when we get to BABEL)
require('script!./WebContent/src/vendor/es5-shim-master/es5-shim');
require('script!./WebContent/src/vendor/shim');

var jQuery = require('jquery');
window.jQuery = window.$ = jQuery; // Some libraries require jQuery to be global.
require('angular');
require('angular-resource');
require('script!./WebContent/src/vendor/angular-shim-placeholder/angular-shims-placeholder.min.js');
require('angular-cookies');
require('angular-sanitize');
require('angular-route');
require('angular-animate');

//kendo
require('script!./WebContent/src/vendor/kendo/src/js/kendo.all.min');
require('script!./WebContent/src/vendor/ifast-overrides/kendo-validation-extractMessage');
/* load culture script  */
require('script!./WebContent/src/vendor/kendo/src/js/cultures/kendo.culture.en.min');
require('script!./WebContent/src/vendor/kendo/src/js/cultures/kendo.culture.fr.min');
require('script!./WebContent/src/vendor/angular-kendo/angular-kendo');
require('bootstrap');
require('script!./WebContent/src/vendor/angular-ui-bootstrap/ui-bootstrap-custom-tpls-1.1.2');

require('angulartics');
require('script!./WebContent/src/vendor/angular-recaptcha/angular-no-captcha');



//////////////////
// WEBPACK FOOTER
// ./vendor-login.js
// module id = 1240
// module chunks = 2